import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

type FilterCardWrapperProps = {
    children: ReactNode;
    "data-automation"?: string;
};

export const FilterCardWrapper = ({ children, "data-automation": dataAutomation }: FilterCardWrapperProps) => (
    <Stack
        padding="16px"
        border={`1px solid ${carbon[100]}`}
        borderRadius="6px"
        gap="16px"
        minWidth="max-content"
        data-automation={dataAutomation}
        background={carbon[25]}
    >
        {children}
    </Stack>
);
